'use client'

import LiquidityPage from 'compositions/liquidity/LiquidityPage'


export default LiquidityPage
